import React, { useState, useEffect, useCallback } from 'react';
import List from "./List.js"
import AuthService from "services/auth.service";

function ListOfLists({ userLists }) {
  const [lists, setLists] = useState([]);
  const [visibleLists, setVisibleLists] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (userLists.length > 0) {
      setLists(userLists);
    }
  }, [userLists]);

  // Load the latest 3 lists when the component mounts
  useEffect(() => {
    if (lists.length > 0) {
      setVisibleLists(lists.slice(0, 3));
      setLoaded(true);
    }
  }, [lists]);

  // Load more lists when the user scrolls to the bottom
  const handleScroll = useCallback(() => {
    if (document.documentElement.scrollHeight <=
      window.innerHeight + document.documentElement.scrollTop + 1
    ) {
      const visibleCount = visibleLists.length;
      const remainingLists = lists.slice(visibleCount);

      if (remainingLists.length > 0) {
        const nextBatch = remainingLists.slice(0, 3);
        setVisibleLists(prevVisibleLists => [...prevVisibleLists, ...nextBatch]);
      }
    }
  }, [lists, visibleLists]);

  useEffect(() => {
    if (loaded) {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [loaded, handleScroll]);

  return (
    <div className="w-full">
      {visibleLists.map(list => (
        <List key={list._id} list={list} />
      ))}
    </div>
  );
}

export default ListOfLists;